import React, { Component } from 'react';
import Day from './Day';

class Days extends Component {
    shouldComponentUpdate(nextProps) {
        return (
            this.props.isScrolled !== nextProps.isScrolled ||
            this.props.days !== nextProps.days ||
            this.props.selected !== nextProps.selected
        );
    }
    render() {
        const tableDays = this.props.days.map(d => {
            return (
                <Day
                    small={this.props.days.length > 5}
                    selectDay={this.props.selectDay}
                    key={d.fullDate}
                    selected={this.props.selected}
                    fullDate={d.fullDate}
                    weekDay={d.weekDay}
                    dayAndMonth={d.dayAndMonth}
                />
            );
        });
        return <ul className="ckp-timetable-actions-group">{tableDays}</ul>;
    }
}

export default Days;



// WEBPACK FOOTER //
// ./src/components/application/timetable/time/Days.js